(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdl-cart-recommendations"] && !Shopify.designMode) return;
  try {
    
  class PdlCartRecommendationsSection extends HTMLElement {
    connectedCallback() {
      if (this.dataset.loaded === 'true') return;
      this.dataset.loaded = 'true';
      this.load();
    }

    async load() {
      const url = this.dataset.url;
      if (!url) {
        this.remove();
        return;
      }

      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error();

        const html = await response.text();
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const loadedSection = parsed.querySelector(`#${CSS.escape(this.id)}`);
        const loadedGrid = loadedSection?.querySelector('.pdl-cart-recommendations__grid');

        if (!loadedSection || !loadedGrid || loadedGrid.children.length === 0) {
          this.remove();
          return;
        }

        this.innerHTML = loadedSection.innerHTML;
        this.hidden = false;
      } catch (error) {
        this.remove();
      }
    }
  }

  if (!customElements.get('pdl-cart-recommendations')) {
    customElements.define('pdl-cart-recommendations', PdlCartRecommendationsSection);
  }

  } catch(e) { console.error(e); }
})();
})();
